// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-btns[data-v-27428536]{display:flex;height:100%}.client-btns .btn-item[data-v-27428536]{display:flex;align-items:center;padding:0 .7em;transition:all .1s;font-size:14px;cursor:pointer}.client-btns .btn-item[data-v-27428536]:hover{color:#fff;background:rgba(0,0,0,.1)}.client-btns .btn-item.close[data-v-27428536]:hover{background:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
